export const environments = { };
export const eventNames = {
    reinforce: 'reinforce',
    reinvent: 'awsreinvent'
};
export const hostNames = {
    test: 'd3ichewryl1jmm.cloudfront.net',
    stage: 'd34p1irbvqs9j.cloudfront.net',
};
export const cognitoEnv = new Map([
    ['localhost', 'test'],
    ['d3ichewryl1jmm.cloudfront.net' , 'test'],
    ['d34p1irbvqs9j.cloudfront.net', 'stage'],
    ['auth.awsevents.com' , 'prod']
  ]);

export const eventSettings = {
    reinforce: {
        showAttendeePortalButton: false,
        attendeePortalUrl: {
            test: 'https://awsreinforce23-stage.mpeventapps.com/auth/login/cognito',
            stage: 'https://awsreinforce23-stage.mpeventapps.com/auth/login/cognito',
            prod: 'https://awsreinforce23.mpeventapps.com/auth/login/cognito'
        }
    },
    awsreinvent: {
        showAttendeePortalButton: false,
        attendeePortalUrl: {
            test: 'https://awsreinvent23-dev.mpeventapps.com/attendee-portal',
            stage: 'https://awsreinvent23-stage.mpeventapps.com/attendee-portal',
            prod: 'https://awsreinvent23.mpeventapps.com/attendee-portal'
        }
    }
};